import { render } from "./HeroAuthLeaveDashboard.vue?vue&type=template&id=0e70d26c&scoped=true"
import script from "./HeroAuthLeaveDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthLeaveDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthLeaveDashboard.vue?vue&type=style&index=0&id=0e70d26c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e70d26c"]])

export default __exports__